import React from 'react';
import { Typography } from '@mui/material';
import DocumentLogo from '../../../../assets/Admin/document-logo.svg';
import {
  getDocumentDisplayName,
  getDocumentViewHref,
  openDocumentInNewTab,
} from '../../../../utils/documentUtils';

/**
 * Shows fixed document label with dynamic file extension from the upload URL.
 * Example: baseName "Document" + .png upload => "Document.png"
 */
const DocumentViewLink = ({ fileUrl, fallbackName = 'Document', className = '' }) => {
  if (!fileUrl) {
    return <Typography className="personal-information-value-text">---</Typography>;
  }

  const displayName = getDocumentDisplayName(fileUrl, fallbackName);
  const href = getDocumentViewHref(fileUrl);

  const handleViewClick = event => {
    event.preventDefault();
    console.log('[DocumentView] link clicked', {
      fallbackName,
      displayName,
      fileUrl,
      href,
    });
    openDocumentInNewTab(fileUrl, displayName);
  };

  return (
    <div className={`flex items-center gap-2 ${className}`.trim()}>
      <img src={DocumentLogo} alt="Document" className="w-[18] h-[18]" />
      <Typography className="personal-information-value-text">{displayName}</Typography>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="view-button"
        onClick={handleViewClick}
      >
        View
      </a>
    </div>
  );
};

export default DocumentViewLink;
